/**
 * // Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyACoHhBITwabnIiOCOpiauyQ5ZxGlVK-88",
  authDomain: "devinresume.firebaseapp.com",
  projectId: "devinresume",
  storageBucket: "devinresume.firebasestorage.app",
  messagingSenderId: "855443634626",
  appId: "1:855443634626:web:eb7a21550c7d3c40763e5b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
 */


export const environment = {
  production: false,
  api_url: 'https://trex.devinresume.com/api/v1',
  // api_url: 'http://127.0.0.1:5001/devinresume/us-central1/dr_trex_app/api/v1',
  firebaseConfig: {
    apiKey: "AIzaSyACoHhBITwabnIiOCOpiauyQ5ZxGlVK-88",
    authDomain: "devinresume.firebaseapp.com",
    projectId: "devinresume",
    storageBucket: "devinresume.firebasestorage.app",
    messagingSenderId: "855443634626",
    appId: "1:855443634626:web:eb7a21550c7d3c40763e5b"
  }
};
